export function u3302IsHexColor(value: string): boolean {
  return /^#[0-9A-Fa-f]{6}$/.test(value);
}
